import { useEffect, useState } from "react";
import { toast } from "sonner";
import { GitMerge, Loader2 } from "lucide-react";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { api, errMsg } from "@/lib/api";
import { chiaveNome } from "@/lib/format";
import { SimpleSelect, btnGhost, btnPrimary } from "@/components/app/common";

const LABELS = { prodotti: "prodotti", spese_brand: "spese brand", movimenti: "movimenti di costo" };

export function UnisciMarcheDialog({ keep, marche, onClose, onDone }) {
  const [dup, setDup] = useState("");
  const [prev, setPrev] = useState(null);
  const [busy, setBusy] = useState(false);
  useEffect(() => {
    // Preselect the likely duplicate (same normalized name or same first word).
    const altre = marche.filter((m) => m.id !== keep?.id);
    const k = chiaveNome(keep?.nome);
    const sim = altre.find((m) => chiaveNome(m.nome) === k) || altre.find((m) => chiaveNome(m.nome.split(/\s+/)[0]) === chiaveNome(keep?.nome.split(/\s+/)[0]));
    setDup(sim?.id || ""); setPrev(null);
  }, [keep, marche]);
  useEffect(() => {
    setPrev(null);
    if (keep && dup) api.get(`/marche/${keep.id}/unisci/${dup}`).then((r) => setPrev(r.data)).catch((e) => toast.error(errMsg(e)));
  }, [keep, dup]);
  const go = async () => {
    setBusy(true);
    try {
      const { data } = await api.post(`/marche/${keep.id}/unisci/${dup}`);
      toast.success(`Marche unite in «${data.marca.nome}»`);
      onDone(); onClose();
    } catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };
  return (
    <Dialog open={!!keep} onOpenChange={(o) => !o && !busy && onClose()}>
      <DialogContent className="rounded-2xl sm:max-w-lg" data-testid="unisci-marche-dialog">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2"><GitMerge className="h-5 w-5 text-[#8C6D62]" />Unisci marche</DialogTitle>
          <DialogDescription>Mantieni <b>{keep?.nome}</b> e unisci qui un duplicato (es. scritto in modo diverso): prodotti e spese brand passano a questa marca, poi il duplicato viene eliminato.</DialogDescription>
        </DialogHeader>
        <SimpleSelect testId="unisci-marca-duplicato-select" value={dup} onChange={setDup} placeholder="Scegli la marca duplicata da eliminare"
          options={marche.filter((m) => m.id !== keep?.id).map((m) => ({ value: m.id, label: `${m.nome} (${m.n_prodotti} prodotti)` }))} />
        {prev && (
          <div className="rounded-xl bg-[#FAF7F5] p-4 text-sm space-y-2" data-testid="unisci-marche-riepilogo">
            <div>Verrà eliminata <b>{prev.elimina.nome}</b>. Passeranno a <b>{prev.mantieni.nome}</b>:</div>
            <ul className="flex flex-wrap gap-x-5 gap-y-1 text-xs">{Object.entries(prev.conteggi).map(([k, v]) => <li key={k} data-testid={`unisci-marche-count-${k}`}><b className="tabular">{v}</b> {LABELS[k]}</li>)}</ul>
          </div>
        )}
        <div className="flex justify-end gap-2">
          <Button variant="outline" className={btnGhost} onClick={onClose} disabled={busy} data-testid="unisci-marche-annulla">Annulla</Button>
          <Button className={btnPrimary} onClick={go} disabled={!prev || busy} data-testid="unisci-marche-conferma">{busy ? <Loader2 className="h-4 w-4 animate-spin" /> : "Unisci ed elimina duplicato"}</Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
